// src/components/Skills.jsx
import React from 'react';
import '../styles/styles.css';

const Skills = () => {
  return (
    <section className="skills" id="skills">
      <h2>My Skills</h2>
      <div className="skills-grid">
        <span>HTML</span>
        <span>CSS</span>
        <span>JavaScript</span>
        <span>React</span>
        <span>React Native</span>
        <span>Shopify</span>
        <span>WordPress</span>
        <span>Liquid</span>
        <span>Amazon PPC</span>
        <span>Project Management</span>
      </div>
    </section>
  );
};

export default Skills;
